// extracted by mini-css-extract-plugin
export default {"root":"ClientProfileLayout_root__RmG9X","wrapper":"ClientProfileLayout_wrapper__hZl1m","content":"ClientProfileLayout_content__+2CJq"};